export const CABINET_LAYOUT = 'cabinet'
export const EMPTY_LAYOUT = 'empty'